const { getCookie } = require('../cookies')
const { size } = require('../size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @returns {string|undefined}
 */
function getGAClientId () {
  if (typeof window === 'undefined') return

  let gaClientId = ''
  const cookie = getCookie('_ga')

  if (size(cookie) > 0) {
    const cookieValues = cookie.split('.')
    if (!cookieValues[2] || !cookieValues[3]) return
    gaClientId = `${cookieValues[2]}.${cookieValues[3]}`
  }

  return gaClientId || undefined
}

module.exports = { getGAClientId }
